var app = angular.module("leonardo");

var AdminSectorListController = function($scope,$state, ngDialog, $controller, SectorRestService) {

  $scope.getEntitiesPromise = function(options) {
    return SectorRestService.getlist(options);
  };

  $scope.showEditSector = function(sector){
    ngDialog.open({
      controller: 'SectorEditDialog',
      templateUrl: 'views/templates/dialog/admin/fields/sector.html',
      data: {
        sector: sector
      }
    });
  };

  $scope.showDeleteSector = function (sector) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: sector,
        type: 'sector'
      }
    }).then(function(data){
      SectorRestService.updateCollection(data, true);
      $scope.loadPage($scope.page);
    });
  };

  $scope.$on('sector:changed', function($event, key, value) {
    $scope.loadPage(1);
  });

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage(1);
};

app.controller('AdminSectorListController', ['$scope', '$state', 'ngDialog', '$controller', 'SectorRestService', AdminSectorListController]);
